/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supply_Air_Min_Temperature_SetpointInputs */



/**
* | output |
* | --- |
* | "Minimum supply setpoint" |
*
* @param {Supply_Air_Min_Temperature_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const supply_air_min_temperature_setpoint = /** @type {((inputs?: Supply_Air_Min_Temperature_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supply_Air_Min_Temperature_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Minimum supply setpoint")
	return /** @type {LocalizedString} */ ("Consigne minimum soufflage")
});